import * as React from 'react'

import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg'

import { IconProps } from '../icons'

const Star = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <G fill={color} clipPath="url(#a)">
      <Path d="m8.384 5.728 1.514.547c.154.052.154.265 0 .325l-1.514.548c-.659.24-1.18.76-1.42 1.42l-.547 1.513c-.051.154-.265.154-.325 0l-.547-1.514a2.378 2.378 0 0 0-1.42-1.42L2.611 6.6c-.154-.051-.154-.265 0-.325l1.514-.547a2.378 2.378 0 0 0 1.42-1.42l.547-1.513c.051-.154.265-.154.325 0l.547 1.513c.24.659.761 1.18 1.42 1.42ZM16.134 9.163l1.244.45a.14.14 0 0 1 0 .265l-1.244.45a1.95 1.95 0 0 0-1.164 1.164l-.45 1.244a.14.14 0 0 1-.264 0l-.45-1.244a1.949 1.949 0 0 0-1.165-1.164l-1.244-.45a.14.14 0 0 1 0-.265l1.244-.45A1.95 1.95 0 0 0 13.806 8l.45-1.244a.14.14 0 0 1 .264 0L14.97 8a1.95 1.95 0 0 0 1.164 1.164ZM9.123 14.588l1.04.378a.116.116 0 0 1 0 .22l-1.04.379c-.449.167-.81.52-.977.978l-.379 1.039a.116.116 0 0 1-.22 0l-.379-1.04a1.65 1.65 0 0 0-.977-.977l-1.04-.379a.116.116 0 0 1 0-.22l1.04-.378c.449-.168.81-.52.977-.978l.379-1.039a.116.116 0 0 1 .22 0l.379 1.04c.167.448.52.81.977.976Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h20v20H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)
export default Star
